import { render, staticRenderFns } from "./Servings.vue?vue&type=template&id=2ebb4fa4&scoped=true"
import script from "./Servings.vue?vue&type=script&lang=ts"
export * from "./Servings.vue?vue&type=script&lang=ts"
import style0 from "./Servings.vue?vue&type=style&index=0&id=2ebb4fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb4fa4",
  null
  
)

export default component.exports